import React, { FC } from 'react'
import { Table, Tooltip } from '@wmgtech/legato'

import { cn } from 'shared/utils'
import { ArtistConcert } from 'shared/__gql-types'
import { formatDate } from 'shared/utils/formatDate'

import songkickLogo from 'assets/images/logo-songkick.png'

import styles from './ConcertsTable.module.scss'

type TTourTableProps = {
  title?: string
  noDataText?: string
  concerts: ArtistConcert[]
}

export const ConcertsTable: FC<TTourTableProps> = ({
  concerts,
  title = 'Tour Dates',
  noDataText = 'No upcoming events found'

}) => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h4 className={cn('lgt-title', styles.title)}>
          {title}
          <Tooltip message="Tour provided by Songkick" colorType="dark">
            <img src={songkickLogo} alt="Songkick logo" className={styles.songkickLogo} />
          </Tooltip>
        </h4>
      </div>

      <Table
        data={concerts}
        condensed={true}
        pagination={false}
        emptyText={<div className={styles.noData}>{noDataText}</div>}
        // TODO: find better unique key
        rowKey={(concert: ArtistConcert) => concert.date + (concert?.cityName || '') + concert.countryName + concert.venue +concert.attendees}
        columns={[
          {
            title: 'Date',
            dataIndex: 'date',
            render: (date: string) => (
              <span style={{ whiteSpace: 'nowrap' }}>{formatDate({ date, withTime: false })}</span>
            )
          }, {
            title: 'City',
            render: (concert: ArtistConcert) => (
              `${concert.countryName}, ${concert.cityName}`
            )
          }, {
            title: 'Venue',
            dataIndex: 'venue'
          }
        ]}
      />
    </div>
  )
}
